import axios from 'axios'

window.axios = axios
export const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  responseType: 'json',
  timeout: 10000
})
